import { render } from "./BaseAppButton.vue?vue&type=template&id=562e859e&scoped=true"
import script from "./BaseAppButton.vue?vue&type=script&lang=js"
export * from "./BaseAppButton.vue?vue&type=script&lang=js"

import "./BaseAppButton.vue?vue&type=style&index=0&id=562e859e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sciam\\Desktop\\Workspaces\\local\\workspace_vue\\alternativa-takeaway-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-562e859e"]])

export default __exports__